import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalOverlay,
  ThemingProps,
} from "@chakra-ui/react";
import React from "react";

export interface ModalWrapperProps {
  title?: string;
  children: React.ReactNode;
  footer: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  size: ThemingProps<"Modal">["size"];
}

function ModalWrapper(props: ModalWrapperProps) {
  const { children, footer, isOpen, onClose, title, size } = props;

  return (
    <Modal size={size} isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        {title && (
          <ModalHeader data-testid={`${title}-header`}>{title}</ModalHeader>
        )}
        <ModalCloseButton />
        <ModalBody>{children}</ModalBody>
        <ModalFooter>{footer}</ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default ModalWrapper;
